export default __webpack_public_path__ + "media/images/casatb/tenant/diamond-three-fe38efb1f854b2c8c0b174ba3d2494bd.png";